<template>
  <div class="worldofzain--subcontinets africa">
    <Header></Header>
        <div class="container">
            <div class="fixed-wrapper">
                <div class="subcontinets_top-bar">
                    <ul>
                        <li>
                            <router-link :to="`/${$i18n.locale}/world-of-zain/middleeast`" >{{$t("labels.middleEast")}}</router-link>
                        </li>
                        <li>
                            <router-link class="active" :to="`/${$i18n.locale}/world-of-zain/africa`">{{$t("labels.africa")}}</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="landing"> 
            <div class="container">
                <region-stats :stats="this.data.africa.stats" :map-image="this.data.africa.mapimage"></region-stats>
            </div>
        </div>
        
        <div class="countries-wrapper">
            
            <svgPath></svgPath>
            <country :countries="this.data.africa.countries"></country>
        </div>
       

  </div>
</template>

<script>
import data from '@/components/worldOfZain/worldOfZain';
import regionStats from '@/components/worldOfZain/regionStats';
import country from '@/components/worldOfZain/country';
import svgPath from '@/components/worldOfZain/path';
export default {
    data(){
        return{
            data: data
        }
    }, 
    components:{
        regionStats,
        country,
        svgPath
    },
    created(){
        this.$i18n.locale=="en" ? 
            this.data = this.data.en :
            this.data = this.data.ar
    },
    mounted(){
        this.worldOfZain();
        
    },
}
</script>
<style>
[data-page='worldofzain-africa'] .wrapper{
    overflow: hidden;
}
</style>
<style lang="scss" scoped>
@import "@/assets/sccs/worldofzain.scss";

.worldofzain--subcontinets {
    padding-bottom:rem(60px);
    position:relative;
    &:after{
        content:"";
        position:absolute;
        width:100%;
        height:100%;
        background: url("../assets/images/banners/worldofzain-continent.jpg") center center no-repeat;
        background-attachment: fixed;
        background-size:cover;
        left:0;
        top:0;
        z-index:-1;

    }
    .animation{
        @media screen and (max-width:767px){
            display:none;
        }
    }
    &.africa {
        padding:rem(30px) 0;
        /deep/{
            .circle-chart__circle{
                stroke:#00a8e6;
            }
        }
        .subcontinets_top-bar {
           
            ul {
               
                li {
                   
                    a {
                        
                        &.active , &:hover {
                            color: #00adef;
                        }
                        &.active{
                            pointer-events: none;
                        }
                    }
                }
            }
            
        }
        @media screen and (max-width:991px) and (min-width:768px){
            .cotinent-desc{
                &:after{
                    left:37px;
                }
            }
        }
        @media screen and (max-width:767px){
            .cotinent-desc{
                &:after{
                    top:54%;
                }
            }
        }
    }

    /deep/{
        svg#motionpath{
            top: 110px;
            @media screen and (max-width:1600px){
                top: 220px;
                right: -80px;
            }
            @media screen and (max-width:1300px){
                top:153px;
                right: -120px;
            }
            @media screen and (max-width:1199px){
                right: -185px;
            }
            @media screen and (max-width:991px){
                right: -185px;
            }
        }
    }
}

[lang="ar"]{
    .worldofzain--subcontinets {
        &:after{
            transform:scaleX(-1);
        }
        &.africa {
        //    @media screen and (max-width:767px){
        //         .cotinent-desc{
        //             &:after{
        //                 top:57%;
        //             }
        //         }
        //     }
        }
    }
}

</style>